<template>
    <div class="flex flex-col dark:text-white">
        <div
            class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs p-5"
        >
            <div class="grid grid-cols-3 gap-2 mb-4">
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CLIENTE</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >{{ order.customer.name }}</span
                    >
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >EMAIL</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >{{ order.customer.email }}</span
                    >
                </div>
                <div
                    class="flex flex-col"
                    v-if="order.customer && order.customer.cpf"
                >
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CPF</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.customer.cpf
                    }}</span>
                </div>
                <div
                    class="flex flex-col"
                    v-if="order.customer && order.customer.cnpj"
                >
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CNPJ</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.customer.cnpj
                    }}</span>
                </div>
                <div
                    class="flex flex-col"
                    v-if="order.customer && order.customer.phones"
                >
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >TELEFONES</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-for="phone in order.customer.phones"
                    >
                        {{ "+" + phone.ddi || "" }} ({{ phone.ddd }})
                        {{ formatPhone(phone.number) }}</span
                    >
                </div>
            </div>

            <div
                class="grid grid-cols-7 grid-flow-row gap-3 mb-4"
                v-if="order"
                v-for="address in order.addresses"
            >
                <div class="flex flex-col col-span-7 mt-4">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >{{ addressTitle(address.is_default) }}</span
                    >
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CEP</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.zip_code
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Rua</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.street
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Número</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.street_number
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Complemento</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.complement
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Referencia</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.reference
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Bairro</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.neighborhood
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Cidade</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.city
                    }}</span>
                </div>
                <div class="flex flex-col col-span-2">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Estado</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        address.state
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelperMixin from "../../mixins/HelperMixin.vue";

export default {
    props: ["order"],
    mixins: [HelperMixin],
    data() {
        return {
            loading: false,
            next_page_url: false,
            commissions: [],
            filters: {
                text: "",
                status: [],
                payment_method: [],
            },
        };
    },
    methods: {
        addressTitle(isDefault) {
            if (isDefault) {
                return "Endereço Principal";
            }
            return "Endereço Secundário";
        },
    },
};
</script>
